module.exports = __webpack_public_path__ + "static/media/barcodeImage_128.78388850.svg";